import { render, staticRenderFns } from "./detail_users_admin_pague.vue?vue&type=template&id=0356212c&scoped=true"
import script from "./detail_users_admin_pague.vue?vue&type=script&lang=js"
export * from "./detail_users_admin_pague.vue?vue&type=script&lang=js"
import style0 from "./detail_users_admin_pague.vue?vue&type=style&index=0&id=0356212c&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0356212c",
  null
  
)

export default component.exports